import { makeStyles } from '@material-ui/core/styles';
import imgBackground from '../../assets/img/indique-ganhe/background.png';

const useStyles = makeStyles((theme) => ({
  root: {},
  header: {
    background: `url("${imgBackground}") repeat`,
    paddingTop: theme.spacing(3),
  },
  content: {
    paddingBottom: theme.spacing(3),
  },
  divider: {
    backgroundColor: theme.palette.secondary.light,
  },
  imgBanner: {
    width: 160,
  },
  tabBtn: {
    borderRadius: 20,
    '&:not(.MuiButton-containedSecondary)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  tabPanel: {
    padding: 0,
  },
  parceiroLabel: {
    backgroundColor: '#fff',
    borderRadius: 5,
    flex: 1,
    margin: 8,
    minWidth: 80,
    padding: 8,
  },
}));

export default useStyles;
